import {Dropdown, DropdownItem} from "../../../../components";
import {Member, MemberType, Trustee} from "../../../model/EstateFlowchartTypes";
import "./_single-beneficiary-field.scss";
import React from "react";

interface SingleBeneficiaryFieldProps {
    beneficiaries: Trustee[];
    beneficiaryOptions: Member[];
    onChange: (beneficiaries: Trustee[]) => void;
}

function SingleBeneficiaryField(
    {
        beneficiaries,
        beneficiaryOptions,
        onChange
    }: Readonly<SingleBeneficiaryFieldProps>) {

    const listHeight = (object: any) => {
        return object.length * 34 < 280 ? (object.length * 34) + 20 : 280
    }

    return (
        <div className="layout-data-entry-form__field">
            <label id="beneficiaryLabel" className={"h5"} aria-label={'beneficiary'}
                   htmlFor="beneficiaryDropdown">Beneficiary</label>
            <Dropdown
                data-testid='beneficiaries-dropdown'
                aria-labelledby="beneficiaryDropdown"
                className='beneficiaryDropdown'
                onChange={(e) => {
                    const updatedBeneficiary = [{
                        trustId: undefined,
                        memberId: e.value,
                        memberType: MemberType.Beneficiary,
                        familyMember: true,
                        customName: "",
                        memberOrder: undefined
                    } as Trustee]
                    onChange(updatedBeneficiary);
                }}
                buttonSize='medium'
                iconNameClose="arrow_drop_up"
                iconNameOpen="arrow_drop_down"
                id="beneficiaryDropdown"
                name="beneficiary"
                value={beneficiaries?.[0]?.memberId ?? ""}
                alignRight={false}
                nativeOnMobile={false}
                dropUp={false}
                virtualScroll={false}
                panelHeight={listHeight(beneficiaryOptions)}
            >
                {beneficiaryOptions.map((member: Member) => (
                    <DropdownItem
                        key={member.value}
                        value={member.value}
                        itemText={member.label}
                    />
                ))}
            </Dropdown>
        </div>
    );
}

export default SingleBeneficiaryField;